import Box from "@mui/material/Box";
import React, { useState, useEffect, useRef } from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

interface GameTimerProps {
  elapsedTime?: number;
  isStarted?: boolean;
  isRunning?: boolean;
}

const GameTimer: React.FC<GameTimerProps> = ({ isStarted, isRunning }) => {
  const [curElapsedTimeInMin, setCurElapsedTimeInMin] = useState(0);
  const isMobile = useMediaQuery(`(max-width: 760px)`);

  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isStarted) {
      return;
    }
    if (isRunning) {
      intervalRef.current = window.setInterval(() => {
        setCurElapsedTimeInMin(curElapsedTimeInMin + 1);
      }, 83);
    } else {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
      }
    }
    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
      }
    };
  }, [isStarted, isRunning, curElapsedTimeInMin]);

  const days = String(
    Math.floor(curElapsedTimeInMin / (60 * 24))
  ).padStart(2, "0");
  const hours = String(
    Math.floor((curElapsedTimeInMin / 60) % 24)
  ).padStart(2, "0");
  const minutes = String(Math.floor(curElapsedTimeInMin % 60)).padStart(2, "0");

  const isPaused = isStarted && !isRunning;

  return (
    <Box sx={{ display: "flex", flexDirection: "row" }} className={isPaused ? "blink" : ""}>
      <AccessTimeIcon
        sx={{ fontSize: isMobile ? 35 : 35, marginRight: "10px" }}
        style={{
          color: "orangered",
        }}
      />
      <Box sx={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h2"
            style={{
              color: "orangered",
              fontSize: isMobile ? "18px" : "18px",
              fontWeight: 800,
            }}
          >
            {days}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: 800, fontSize: isMobile ? "10px" : "10px" }}
          >
            days
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h2"
            style={{
              color: "orangered",
              fontSize: isMobile ? "18px" : "18px",
              fontWeight: 800,
            }}
          >
            {hours}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: 800, fontSize: isMobile ? "10px" : "10px" }}
          >
            hrs
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h2"
            style={{
              color: "orangered",
              fontSize: isMobile ? "18px" : "18px",
              fontWeight: 800,
            }}
          >
            {minutes}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: 800, fontSize: isMobile ? "10px" : "10px" }}
          >
            mins
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default GameTimer;
